module.exports={"(optional)":"（可选）","(required)":"（必填）"};